export default __webpack_public_path__ + "static/media/permission-edit-icon.b98d2534.svg";